<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » <a [href]="facilityDialogLink">施設情報（追加・編集）画面</a> » 住所ダイアログの説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>住所ダイアログの説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/address-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、選択した内容は反映されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 全言語自動翻訳
        </div>
        <div class="manual-explain">
          全言語の自動翻訳チェックボックスに対して、ON/OFFを切り替えます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 住所（メイン言語）
        </div>
        <div class="manual-explain">
          住所を設定します。<br>
          <a [href]="projectDialogLink">プロジェクト情報：編集画面</a>で設定された言語の１番目のものがメイン言語となります。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 住所（翻訳用）
        </div>
        <div class="manual-explain">
          自動翻訳用の住所を設定します。<br>
          ここで設定された内容をもとに各言語の翻訳を行います。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 住所（他言語）
        </div>
        <div class="manual-explain">
          住所を設定します。<br>
          自動翻訳チェックボックスをONにすることで翻訳処理が実行されます。（設定内容は翻訳処理によって上書きされます）
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集した内容を反映します。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 住所（翻訳用）
        </div>
        <div class="manual-explain">
          自動翻訳用の住所を設定します。<br>
          ここで設定された内容をもとに各言語の翻訳を行います。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 住所（他言語）
        </div>
        <div class="manual-explain">
          住所を設定します。<br>
          自動翻訳チェックボックスをONにすることで翻訳処理が実行されます。（設定内容は翻訳処理によって上書きされます）
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集した内容を反映します。
        </div>

      </mat-card-content>
    </mat-card>
  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">Manual Top</a> » <a [href]="facilityDialogLink">Facility Information (Add/Edit) Screen</a> » Address Dialog Description
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

      <mat-card class="manual-card">
        <mat-card-header>
          <mat-card-title><span>Address Dialog Description</span></mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <div class="manual-img">
            <img src="assets/img/manual/address-dialog.png" width="100%">
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/A.png"> Close Button
          </div>
          <div class="manual-explain">
            Clicking this button will close the dialog.<br>
            The selected content will not be applied upon closing.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/B.png"> Auto-Translate All Languages
          </div>
          <div class="manual-explain">
            Toggles the ON/OFF state of the auto-translate checkbox for all languages.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/C.png"> Address (Main Language)
          </div>
          <div class="manual-explain">
            Set the address.<br>
            The first language set in the <a [href]="projectDialogLink">Project Information: Edit Screen</a> becomes the main language.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/D.png"> Address (For Translation)
          </div>
          <div class="manual-explain">
            Set the address for automatic translation.<br>
            The content set here is used as the basis for translations into other languages.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/E.png"> Address (Other Languages)
          </div>
          <div class="manual-explain">
            Set the address.<br>
            When the auto-translate checkbox is ON, translation is performed (the content will be overwritten by the translation process).
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/F.png"> Update Button
          </div>
          <div class="manual-explain">
            Clicking this button applies the edited content.
          </div>

        </mat-card-content>
      </mat-card>

  </div>

</div>